import React, { Fragment, useState } from 'react';
import Input from 'b2b-ui-components-lib/lib/components/input';
import RadioGroup from 'b2b-ui-components-lib/lib/components/radioGroup';
import { getDefaultValue, LINK_TYPE } from './formControl.service';
import { ServiceDetailsSection } from './service-details-section';

export const LocationBodyForMPLS = ({ rowData, isSummaryRender = false }) => {
  const [isPrimaryActive, setIsPrimaryActive] = useState(true);
  const [isSecondaryActive, setIsSecondaryActive] = useState(false);

  const [primaryForm, setPrimaryForm] = useState(getDefaultValue(rowData, LINK_TYPE.PRIMARY, isSummaryRender));
  const [secondaryForm, setSecondaryForm] = useState(getDefaultValue(rowData, LINK_TYPE.SECONDARY, isSummaryRender));

  const handleToggle = () => {
    setIsPrimaryActive(!isPrimaryActive);
  };

  const handleSecondaryToggle = () => {
    setIsSecondaryActive(!isSecondaryActive);
  };

  const defaultValue = 'N/A';

  const options = [
    { id: 'UNMANAGED', displayName: 'Unmanaged Services' },
    { id: 'MANAGED', displayName: 'Managed Services' }
  ];

  const redundancyOptions = [
    { id: 'Yes', displayName: 'Yes' },
    { id: 'No', displayName: 'No' }
  ];

  const getServiceTypeValue = (id) => {
    return options.filter((option) => option.id === id)[0] || options[0];
  };
  return (
    <div className={`${!isSummaryRender ? 'container_area' : ''}`}>
      <div className={`${!isSummaryRender ? 'config_form' : ''}`}>
        {!isSummaryRender && (
          <Fragment>
            <div className="select_info">
              <div className="text">Location Details</div>
            </div>
            <div className="row">
              <div className="flg-lg-6 flg-md-6">
                <Input name="Company Name" type="text" value={rowData.companyName} label="Company Name" required disabled />
              </div>
              <div className="flg-lg-6 flg-md-6">
                <Input name="Selected Bandwidth" type="text" value={rowData.bandwidth ? rowData.bandwidth.toString() : 'N/A'} label="Selected Bandwidth" required disabled />
              </div>
            </div>
            <div className="row">
              <div className="flg-lg-6 flg-md-6">
                <Input name="Media Type" type="text" value={rowData.mediaType ? rowData.mediaType : 'N/A'} label="Media Type" required disabled />
              </div>
              <div className="flg-lg-6 flg-md-6">
                <Input name="Address" type="text" value={rowData.address ? rowData.address : 'N/A'} label="Address" required disabled />
              </div>
            </div>{' '}
          </Fragment>
        )}
        {/* Primary  Body */}
        <div className={`accordion_group_mpls ${isPrimaryActive ? 'active' : ''}`}>
          <div className="accodion_head_title_mpls">
            <h6>PRIMARY LINK</h6> <span className="animatedarrow_mpls" onClick={handleToggle}></span>
          </div>

          <div className="accordion_detialed_info_mpls">
            <div className="config_form">
              <div className="select_info">
                <div className="text">Redundancy</div>
                <div className="tooltip_wrap">
                  <span className="material-icons-outlined">info</span>
                  <div className="tooltip">
                    <div className="tooltip_content">
                      <p>
                        Choose “<strong>No</strong>” for only single link and “<strong>Yes</strong>” for multiple links (Primary and Secondary links).{' '}
                      </p>
                      <ul className="tooltip_list">
                        <li>
                          You may choose <strong>Dual Last Mile</strong> for both Primary and Secondary links in order to maintain high uptime SLA.
                        </li>
                        <li>
                          Choose <strong>Dual POP</strong> for connectivity at your location for 2 different Point of Presence(POP).
                        </li>
                        <li>
                          Choose <strong>Dual Cloud</strong> for using both Airtel Cloud and Third Party Cloud,
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="radio_box">
                <RadioGroup
                  options={redundancyOptions}
                  value={{
                    id: primaryForm.redundancy.value,
                    value: primaryForm.redundancy.value
                  }}
                  disabled={true}
                />
              </div>
              <div className="row">
                <div className="flg-lg-6 flg-md-6">
                  <Input label="Last Mile" value={primaryForm.lastMile.value ?? defaultValue} disabled={true} required />
                </div>
              </div>
              <div className="select_info">
                <div className="text">
                  <span className="material-icons">info</span> All the attributes for secondary link is same as primary link{' '}
                </div>
              </div>
              <div className="row">
                <div className="flg-lg-6 flg-md-6">
                  <Input label="POP" value={primaryForm.pop.value ?? defaultValue} disabled={true} required />
                </div>
                <div className="flg-lg-6 flg-md-6">
                  <Input label="CPE" value={primaryForm.cpeType.value ?? defaultValue} disabled={true} required />
                </div>
              </div>
              <div className="row">
                <div className="flg-lg-6 flg-md-6">
                  <Input label="Cloud" value={primaryForm.cloud.value ?? defaultValue} disabled={true} required />
                </div>
              </div>

              <div className="select_info">
                <div className="text">Bandwidth </div>
                <div className="tooltip_wrap">
                  <span className="material-icons-outlined">info</span>
                  <div className="tooltip">
                    <div className="tooltip_content">
                      <p>Please note that Port Bandwidth will always be less than or equal to Access Bandwidth.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="flg-lg-6 flg-md-6">
                  <Input label="Port Bandwidth" value={primaryForm.portBandwidth.value ?? defaultValue} placeholder="Port Bandwidth" required disabled={true} />
                </div>
                <div className="flg-lg-6 flg-md-6">
                  <Input label="Access Bandwidth" value={primaryForm.accessBandwidth.value ?? defaultValue} disabled={true} required />
                </div>
              </div>

              <ServiceDetailsSection rowData={rowData}></ServiceDetailsSection>
              <div className="select_info">
                <div className="text">Internet Protocol (IP) Attributes </div>
                <div className="tooltip_wrap">
                  <span className="material-icons-outlined">info</span>
                  <div className="tooltip">
                    <div className="tooltip_content">
                      <p>Define IP Version (IPV4, IPV6 or Dual Stack) according to your requirement.</p>
                      <p>Also note that the sum of Business, Standard, PRT and PRNT bandwidth will be equal to Port Bandwidth.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="flg-lg-6 flg-md-6">
                  <Input label="IP Version" value={primaryForm.ipVersion.value ?? defaultValue} placeholder="IP Version" required disabled={true} />
                </div>
                <div className="flg-lg-6 flg-md-6">
                  <Input label="Routing Protocol" value={primaryForm.routingProtocol.value ?? defaultValue} placeholder="Routing Protocol" required disabled={true} />
                </div>
              </div>
              <div className="row">
                <div className="flg-lg-6 flg-md-6">
                  <Input label="Quality of Service" value={primaryForm.qos.value ?? defaultValue} placeholder="Quality of Service" required disabled={true} />
                </div>
                <div className="flg-lg-6 flg-md-6">
                  <Input
                    label="Business (Mbps)"
                    disabled={true}
                    required
                    maxlength={5}
                    value={primaryForm.business.value ?? defaultValue}
                    errors={primaryForm.business.errors}
                    touched={primaryForm.business.touched}
                  />
                </div>
              </div>
              <div className="row">
                <div className="flg-lg-6 flg-md-6">
                  <Input
                    label="Standard (Mbps)"
                    disabled={true}
                    required
                    maxlength={5}
                    value={primaryForm.standard.value ?? defaultValue}
                    errors={primaryForm.standard.errors}
                    touched={primaryForm.standard.touched}
                  />
                </div>
                <div className="flg-lg-6 flg-md-6">
                  <Input
                    label="PRT (Mbps)"
                    required
                    disabled={true}
                    maxlength={5}
                    value={primaryForm.prt.value ?? defaultValue}
                    errors={primaryForm.prt.errors}
                    touched={primaryForm.prt.touched}
                  />
                </div>
              </div>
              <div className="row">
                <div className="flg-lg-6 flg-md-6">
                  <Input
                    label="PNRT (Mbps)"
                    maxlength={5}
                    disabled={true}
                    value={primaryForm.pnrt.value ?? defaultValue}
                    errors={primaryForm.pnrt.errors}
                    touched={primaryForm.pnrt.touched}
                    required
                  />
                </div>
              </div>
              <div className="select_info">
                <div className="text">VPN </div>
                <div className="tooltip_wrap">
                  <span className="material-icons-outlined">info</span>
                  <div className="tooltip">
                    <div className="tooltip_content">
                      <p>Define IP Version (IPV4, IPV6 or Dual Stack) according to your requirement.</p>
                      <p>Also note that the sum of Business, Standard, PRT and PRNT bandwidth will be equal to Port Bandwidth.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="flg-lg-6 flg-md-6">
                  <Input label="VPN Type" value={primaryForm.vpnType.value ?? defaultValue} placeholder="VPN Type" required disabled={true} />
                </div>
                <div className="flg-lg-6 flg-md-6">
                  <Input label="VPN Topology" value={primaryForm.vpnTopology.value ?? defaultValue} placeholder="VPN Topology" required disabled={true} />
                </div>
              </div>
              <div className="row">
                <div className="flg-lg-6 flg-md-6">
                  <Input label="Link Topology" value={primaryForm.linkTopology.value ?? defaultValue} placeholder="Link Topology" required disabled={true} />
                </div>
              </div>
            </div>
          </div>
        </div>

        {
          /* SECONDARY */
          secondaryForm.isRecordAvailable && (
            <div className={` ${'accordion_group'} ${isSecondaryActive ? 'active' : ''}`}>
              <div className="accodion_head_title">
                <h6>SECONDARY LINK</h6> <span className="animatedarrow" onClick={handleSecondaryToggle}></span>
              </div>

              <div className="accordion_detialed_info">
                <div className="config_form">
                  <div className="select_info">
                    <div className="text">Bandwidth </div>
                    <div className="tooltip_wrap">
                      <span className="material-icons-outlined">info</span>
                      <div className="tooltip">
                        <div className="tooltip_content">
                          <p>Please note that Port Bandwidth will always be less than or equal to Access Bandwidth.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="flg-lg-6 flg-md-6">
                      <Input label="Port Bandwidth" value={secondaryForm.portBandwidth.value ?? defaultValue} placeholder="Port Bandwidth" required disabled={true} />
                    </div>
                    <div className="flg-lg-6 flg-md-6">
                      <Input label="Access Bandwidth" value={secondaryForm.accessBandwidth.value ?? defaultValue} disabled={true} required />
                    </div>
                  </div>

                  <ServiceDetailsSection rowData={rowData}></ServiceDetailsSection>
                  <div className="select_info">
                    <div className="text">Internet Protocol (IP) Attributes </div>
                    <div className="tooltip_wrap">
                      <span className="material-icons-outlined">info</span>
                      <div className="tooltip">
                        <div className="tooltip_content">
                          <p>Define IP Version (IPV4, IPV6 or Dual Stack) according to your requirement.</p>
                          <p>Also note that the sum of Business, Standard, PRT and PRNT bandwidth will be equal to Port Bandwidth.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="flg-lg-6 flg-md-6">
                      <Input label="IP Version" value={secondaryForm.ipVersion.value ?? defaultValue} placeholder="IP Version" required disabled={true} />
                    </div>
                    <div className="flg-lg-6 flg-md-6">
                      <Input label="Routing Protocol" value={secondaryForm.routingProtocol.value ?? defaultValue} placeholder="Routing Protocol" required disabled={true} />
                    </div>
                  </div>
                  <div className="row">
                    <div className="flg-lg-6 flg-md-6">
                      <Input label="Quality of Service" value={secondaryForm.qos.value ?? defaultValue} placeholder="Quality of Service" required disabled={true} />
                    </div>
                    <div className="flg-lg-6 flg-md-6">
                      <Input
                        label="Business (Mbps)"
                        disabled={true}
                        required
                        maxlength={5}
                        value={secondaryForm.business.value ?? defaultValue}
                        errors={secondaryForm.business.errors}
                        touched={secondaryForm.business.touched}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="flg-lg-6 flg-md-6">
                      <Input
                        label="Standard (Mbps)"
                        disabled={true}
                        required
                        maxlength={5}
                        value={secondaryForm.standard.value ?? defaultValue}
                        errors={secondaryForm.standard.errors}
                        touched={secondaryForm.standard.touched}
                      />
                    </div>
                    <div className="flg-lg-6 flg-md-6">
                      <Input
                        label="PRT (Mbps)"
                        required
                        disabled={true}
                        maxlength={5}
                        value={secondaryForm.prt.value ?? defaultValue}
                        errors={secondaryForm.prt.errors}
                        touched={secondaryForm.prt.touched}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="flg-lg-6 flg-md-6">
                      <Input
                        label="PNRT (Mbps)"
                        maxlength={5}
                        disabled={true}
                        value={secondaryForm.pnrt.value ?? defaultValue}
                        errors={secondaryForm.pnrt.errors}
                        touched={secondaryForm.pnrt.touched}
                        required
                      />
                    </div>
                  </div>
                  <div className="select_info">
                    <div className="text">VPN </div>
                    <div className="tooltip_wrap">
                      <span className="material-icons-outlined">info</span>
                      <div className="tooltip">
                        <div className="tooltip_content">
                          <p>Define IP Version (IPV4, IPV6 or Dual Stack) according to your requirement.</p>
                          <p>Also note that the sum of Business, Standard, PRT and PRNT bandwidth will be equal to Port Bandwidth.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="flg-lg-6 flg-md-6">
                      <Input label="VPN Type" value={secondaryForm.vpnType.value ?? defaultValue} placeholder="VPN Type" required disabled={true} />
                    </div>
                    <div className="flg-lg-6 flg-md-6">
                      <Input label="VPN Topology" value={secondaryForm.vpnTopology.value ?? defaultValue} placeholder="VPN Topology" required disabled={true} />
                    </div>
                  </div>
                  <div className="row">
                    <div className="flg-lg-6 flg-md-6">
                      <Input label="Link Topology" value={secondaryForm.linkTopology.value ?? defaultValue} placeholder="Link Topology" required disabled={true} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )
        }

        {/* Pricing Details footer */}
        {!isSummaryRender && (
          <Fragment>
            <div className="select_info">
              <div className="text">Pricing Details </div>
              <div className="tooltip_wrap">
                <span className="material-icons-outlined">info</span>
                <div className="tooltip">
                  <div className="tooltip_content">Pricing Details</div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="flg-lg-6 flg-md-6">
                <Input
                  name="Annual Rental Price"
                  type="text"
                  value={`₹ ${rowData.rawContent.planDetail ? rowData.rawContent.planDetail.price.amount : 'N/A'}`}
                  label="Annual Rental Price  "
                  required
                  disabled
                />
              </div>
              <div className="flg-lg-6 flg-md-6">
                <Input
                  name="Installation Charge"
                  type="text"
                  value={`₹ ${rowData.rawContent.planDetail ? rowData.rawContent.planDetail.price.otc : 'N/A'}`}
                  label="Installation Charge"
                  required
                  disabled
                />
              </div>
            </div>
            <div className="row">
              <div className="flg-lg-6 flg-md-6">
                <Input
                  name="Contract Period"
                  type="text"
                  value={`${rowData.rawContent.planDetail ? Math.floor(rowData.rawContent.planDetail.planPeriod / 12) : 'N/A'} years`}
                  label="Contract Period"
                  required
                  disabled
                />
              </div>
              <div className="flg-lg-6 flg-md-6">
                <Input
                  name="Total Price"
                  type="text"
                  value={`₹ ${
                    Math.floor(rowData.rawContent.planDetail ? rowData.rawContent.planDetail.planPeriod / 12 : 0) *
                      (rowData.rawContent.planDetail ? rowData.rawContent.planDetail.price.amount : 0) +
                    (rowData.rawContent.planDetail ? rowData.rawContent.planDetail.price.otc : 0)
                  }`}
                  label="Total Price"
                  required
                  disabled
                />
              </div>
            </div>
          </Fragment>
        )}
      </div>
      {!isSummaryRender && rowData.rawContent && !rowData.rawContent.planDetail.standardIp && (
        <div className="notify_text">* Please note: Pricing for the non-standard IP attributes are under review and will be updated after DOA approval.</div>
      )}
    </div>
  );
};
